import ReactiveComponent, { watch } from '@utils/reactive-component';
import AjaxLoader from '../ajax-loader/ajax-loader';
import { context as defaultContext } from './address-book-defaults';
import template from './templates/address-book-line/index';
import addressBookStore from '@stores/address-book/address-book-store';

const CLASS_NAME_HIDDEN = '-hidden';
const CLASS_NAME_LOADING = '-loading';
const CLASS_NAME_VISIBLE = '-visible';

const DEFAULT_OPTIONS = {
    onEdit: null,
    replaceOriginEl: false
};

const DEFAULT_LOADER_OPTIONS = {
    replaceOriginEl: false,
    size: 'lg'
};

export default class AddressBookLine extends ReactiveComponent {
    constructor($originEl, context, addressId, options) {
        super();

        context = {
            ...defaultContext,
            ...context
        };

        options = {
            ...DEFAULT_OPTIONS,
            ...options
        };

        const $parsed = $($.parseHTML(template));
        this.$el = $parsed;
        this.$originEl = $originEl;

        this.$deleteLabel = this.$el.find('[data-label="delete"]');
        this.$editLabel = this.$el.find('[data-label="edit"]');
        this.$primaryLabel = this.$el.find('[data-label="primary"]');

        this.$address = this.$el.find('[data-region="address"]');
        this.$address2 = this.$el.find('[data-region="address2"]');
        this.$addressLine1 = this.$el.find('[data-region="addressLine1"]');
        this.$addressLine2 = this.$el.find('[data-region="addressLine2"]');
        this.$city = this.$el.find('[data-region="city"]');
        this.$country = this.$el.find('[data-region="country"]');
        this.$deleteIcon = this.$el.find('[data-region="deleteIcon"]');
        this.$editIcon = this.$el.find('[data-region="editIcon"]');
        this.$loader = this.$el.find('[data-region="loader"]');
        this.$primaryIcon = this.$el.find('[data-region="primaryIcon"]');
        this.$name = this.$el.find('[data-region="name"]');
        this.$stamp = this.$el.find('[data-region="stamp"]');
        this.$state = this.$el.find('[data-region="state"]');
        this.$zip = this.$el.find('[data-region="zip"]');
        this.$phone = this.$el.find('[data-region="phone"]');

        this.$deleteCtrl= this.$el.find('[data-control="delete"]');
        this.$editCtrl= this.$el.find('[data-control="edit"]');
        this.$primaryCtrl= this.$el.find('[data-control="primary"]');

        this.loader = null;
        this.unwatchLoadingLine = null;

        this.onEdit = options.onEdit;
        this.replaceOriginEl = options.replaceOriginEl;

        this.addressId = addressId;
        this.context = context;

        this.reactive({
            loading: false
        });

        this.init();
    }

    [watch]() {
        return {
            loading(loading) {
                this.loader.active = loading;
                loading ? this.$loader.addClass(CLASS_NAME_LOADING) : this.$loader.removeClass(CLASS_NAME_LOADING);
            }
        }
    }

    init() {
        this.renderLabels();
        this.renderLoader();
        this.renderRegions();
        this.setupListeners();
    }

    destroy() {
        this.unwatchLoadingLine?.();
    }

    focus() {
        this.$el
            .attr('tabindex', '0')
            .one('blur', () => this.$el.removeAttr('tabindex'))
            .get(0)
            .focus();
    }

    onDeleteClick() {
        addressBookStore.actions.deleteAddress(this.addressId);
    }
    
    onEditClick() {
        this.onEdit?.(this.addressId);
    }

    onPrimaryClick() {
        addressBookStore.actions.setPrimary(this.addressId);
    }

    render() {
        if(this.$originEl) {
            if(this.replaceOriginEl) {
                this.$originEl.replaceWith(this.$el);
            } else {
                this.$originEl.html(this.$el);
            }
        }

        return this.$el;
    }

    renderIcons() {
        const img = document.createElement('img');
        img.setAttribute('aria-hidden', true);
        img.setAttribute('alt', '');
        
        if(this.context.DeleteIcon) {
            const icon = img.cloneNode(false);
            icon.src = this.context.DeleteIcon;
            this.$deleteIcon.html(icon);
        } else {
            this.$deleteIcon.hide();
        }

        if(this.context.EditIcon) {
            const icon = img.cloneNode(false);
            icon.src = this.context.EditIcon;
            this.$editIcon.html(icon);
        } else {
            this.$editIcon.hide();
        }

        if(this.context.SetPrimaryIcon) {
            const icon = img.cloneNode(false);
            icon.src = this.context.SetPrimaryIcon;
            this.$primaryIcon.html(icon);
        } else {
            this.$primaryIcon.hide();
        }
    }

    renderLabels() {
        this.$deleteLabel.html(this.context.Delete);
        this.$editLabel.html(this.context.Edit);
        this.$primaryLabel.html(this.context.SetPrimaryButton);
        this.$stamp.html(this.context.Primary);
    }

    renderLoader() {
        this.loader = new AjaxLoader(this.$loader, {
            ...DEFAULT_LOADER_OPTIONS,
            customIcon: this.context.LoadingIcon || null,
            srText: this.context.LoadingSrText || null
        });
        
        this.loader.render();
    }

    renderRegions() {
        this.togglePrimarySections();
        this.renderIcons();

        const info = addressBookStore.getters.addressInfo(this.addressId);

        this.$address.prepend(info.address1);
        this.$address2.prepend(info.address2);
        this.$city.html(info.city);
        this.$country.html(info.country);
        this.$name.html(info.name);
        this.$state.html(info.state);
        this.$zip.html(info.zip);
       // this.$phone.html(info.phone);
    }

    setupListeners() {
        this.$deleteCtrl.on('click', () => this.onDeleteClick());
        this.$editCtrl.on('click', () => this.onEditClick());
        this.$primaryCtrl.on('click', () => this.onPrimaryClick());

        this.unwatchLoadingLine = addressBookStore.watch('loadingLine', () => this.loading = addressBookStore.getters.isLoadingLine(this.addressId));
    }

    togglePrimarySections() {
        if(addressBookStore.getters.isPrimary(this.addressId)) {
            this.$stamp.addClass(CLASS_NAME_VISIBLE);
            this.$primaryCtrl.addClass(CLASS_NAME_HIDDEN);
        }
    }
}
